import request from '@/utils/request';
import { params } from '@/views/google/create/components/trackCreat';

const BASEURL = process.env.VUE_APP_GOOGLE_BASEURL;
const APIFOXURL = 'https://apifoxmock.com/m1/4483932-4130578-default/google';
const BASEYOUTUBE = process.env.VUE_APP_GOOGLE_BASEURL;
const POST = (url, data, config) =>
  request({
    url,
    baseURL: BASEURL,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
    ...config,
  });

const GET = (url, params, config) =>
  request({
    url,
    baseURL: BASEURL,
    method: 'get',
    params,
    ...config,
  });
//   获取频道列表
export const getChannelPageList = (params) => POST('/youtube/manage/channelPage', params, { baseURL: BASEYOUTUBE });
//   更改频道状态
export const setChannelStatus = (params) =>
  POST('/youtube/manage/batchChannelStatus', params, { baseURL: BASEYOUTUBE });
// 删除频道
export const deleteChannel = (params) => POST('/youtube/manage/deleteChannel', params, { baseURL: BASEYOUTUBE });

// 获取所有的频道列表
export const getChannelList = (params) => GET('/youtube/manage/channelList', params, { baseURL: BASEYOUTUBE });

// 授权youtube凭证
export const getAuthUrl = (params) => GET('/auth/getAuthUrl', params, { baseURL: BASEYOUTUBE });

// 获取上传视频进度
export const getVideoProcess = (params) =>
  GET(
    `/youtube/manage/getUploadProcessByIds?recordIds=${params.recordIds}&searchStatus=${params.searchStatus}`,
    {},
    { baseURL: BASEYOUTUBE },
  );

//   获取视频上传记录
export const videoRecord = (params) => POST(`/youtube/manage/videoRecord`, params, { baseURL: BASEYOUTUBE });

// 上传记录详情
export const videoRecordDetail = (params) =>
  POST(`/youtube/manage/videoRecordDetail`, params, { baseURL: BASEYOUTUBE });

// 同步频道
export const syncChannels = (params) => POST(`/youtube/manage/syncChannels`, params, { baseURL: BASEYOUTUBE });

// 获取频道用户
export const channelUserList = (params) => GET(`/youtube/manage/channelUserList`, params, { baseURL: BASEYOUTUBE });

//添加频道用户
export const batchAddChannelUser = (params) =>
  POST(`/youtube/manage/batchAddChannelUser`, params, { baseURL: BASEYOUTUBE });

// 获取用户列表
export const queryGkUser = (params) => GET(`/youtube/manage/queryGkUser`, params, { baseURL: BASEYOUTUBE });

// 删除频道用户
export const deleteChannelUser = (params) =>
  POST(`/youtube/manage/deleteChannelUser`, params, { baseURL: BASEYOUTUBE });
// 异步上传视频
export const asyncUploadVideo = (params) => POST(`/youtube/manage/asyncUploadVideo`, params, { baseURL: BASEYOUTUBE });
// 同步上传视频
export const syncUploadVideo = (params) => POST(`/youtube/manage/syncUploadVideo`, params, { baseURL: BASEYOUTUBE });

// 获取账号下的视频
export const videoPage = (params) => GET(`/youtube/manage/videoPage`, params, { baseURL: BASEYOUTUBE });

// 编辑频道的备注
export const editChannelMark = (params) => GET(`/youtube/manage/channelMark`, params, { baseURL: BASEYOUTUBE });

// 保存优化师日志

export const saveOptLog = (params) => POST(`/media/saveOptLog`, params);

// 根据频道搜索视频
export const searchVideoByChannel = (params) =>
  GET(`/youtube/manage/searchVideoByChannel`, params, { baseURL: BASEYOUTUBE });

// 更新YouTube视频
export const updateYoutubeVideo = (params) =>
  POST(`/youtube/manage/updateYoutubeVideo`, params, { baseURL: BASEYOUTUBE });

// 删除YouTube视频
export const deleteVideo = (params) => GET(`/youtube/manage/deleteVideo`, params, { baseURL: BASEYOUTUBE });

/**
 * 更新视频封面图片
 * @param {Object} params - 请求参数
 * @param {number} params.youtubeChannelId - YouTube 频道 ID
 * @param {string} params.youtubeCredentialId - YouTube 凭证 ID
 * @param {string} params.videoId - 视频 ID
 * @param {string} params.customCoverImage - 自定义封面图片 URL
 * @returns {Promise} 后端响应数据
 */
export const updateVideoCoverImage = (params) =>
  POST('/youtube/manage/updateVideoCoverImage', params, { baseURL: BASEYOUTUBE });

/**
 * 根据 YouTube 链接（或 11 位 videoId）解析视频信息
 * @param {Object} params
 * @param {string} params.videoUrl - watch / youtu.be / shorts / embed / live / videoId
 */
export const parseVideoByUrl = (params) =>
  POST('/youtube/manage/parseVideoByUrl', params, { baseURL: BASEYOUTUBE, hideErrorMessage: true });
